import {
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
  Button,
  Icon,
  Text,
  VStack,
  Box,
} from "@chakra-ui/react";
import { BiSortDown } from "react-icons/bi";
export function Sort() {
  return (
    <VStack align="flex-end">
      <Box>
        <Menu closeOnSelect={true}>
          <MenuButton as={Button} colorScheme="blue">
            <Text fontSize={[16, 18, 20]}>
              Sort <Icon as={BiSortDown} />
            </Text>
          </MenuButton>
          <MenuList maxWidth="240px">
            <MenuOptionGroup defaultValue="asc" title="Order" type="radio">
              <MenuItemOption value="asc">Ascending</MenuItemOption>
              <MenuItemOption value="desc">Descending</MenuItemOption>
            </MenuOptionGroup>
          </MenuList>
        </Menu>
      </Box>
    </VStack>
  );
}
